import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Proctoring',
    label: 'รายละเอียดการคุมสอบ',
    path: '/:examCenterCode/proctoring/exam-events/:examEventId/details',
    requiredPermission: [APP_PERMISSIONS.PROCTORING.DETAILS.VIEW],
  },
  {
    value: 'Examinee Registration',
    label: 'การลงทะเบียนผู้เข้าสอบ',
    path: '/:examCenterCode/proctoring/exam-events/:examEventId/registrations',
    requiredPermission: [APP_PERMISSIONS.PROCTORING.REGISTRATION.VIEW],
  },
  {
    value: 'e-KYC Verification',
    label: 'ตรวจสอบการยืนยันตัวตน (e-KYC)',
    path: '/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc',
    requiredPermission: [APP_PERMISSIONS.PROCTORING.E_KYC.VIEW],
  },
];

export default function ProctoringDetailsNavigationTabs() {
  const { permissions } = usePermission();

  const filteredItems = useMemo(() => {
    return TAB_ITEMS.filter((item) => {
      return item.requiredPermission?.every((permission) => permissions.includes(permission));
    });
  }, [permissions]);

  return <NavigationTabs items={filteredItems} />;
}
